import { type FlowBlockTemplateListQuery } from 'flow-schema';

import { type Common } from '../common.js';
import {
  type CreateFlowBlockTemplateParams,
  type FlowBlockTemplateWithBaseBlock,
  type FlowBlockTemplateWithCreatedBy,
} from '../models/flow/flowBlockTemplate.js';

export class API {
  common: Common;
  // Flow API also serves these at the legacy `/flow/flow-templates`, which never carried flow
  // definition templates. Prefer this path; the legacy one is being retired.
  baseEndpoint = '/flow/flow-block-templates';

  constructor(common: Common) {
    this.common = common;
  }

  async createBlockTemplate(
    params: CreateFlowBlockTemplateParams
  ): Promise<FlowBlockTemplateWithCreatedBy | undefined> {
    const { name, blockTemplate, description, organizationId } = params;
    const url = this.common.constructPath(`${this.baseEndpoint}/blocks`);
    return await this.common.postJSON(url, {
      name,
      blockTemplate,
      description,
      organizationId,
    });
  }

  async findAll(params?: FlowBlockTemplateListQuery): Promise<FlowBlockTemplateWithBaseBlock[]> {
    const url = this.common.constructPath(`${this.baseEndpoint}/blocks`, params);
    return await this.common.getJSON(url);
  }

  async findOneById(blockTemplateId: string): Promise<FlowBlockTemplateWithBaseBlock> {
    const url = this.common.constructPath(`${this.baseEndpoint}/blocks/${blockTemplateId}`);
    return await this.common.getJSON(url);
  }

  async delete(blockTemplateId: string): Promise<boolean> {
    const url = this.common.constructPath(`${this.baseEndpoint}/blocks/${blockTemplateId}`);
    return await this.common.deleteJSON(url);
  }
}
